export default {"src":"/_next/static/media/2-Inkasso.b076b95d.svg","height":87,"width":87,"blurWidth":0,"blurHeight":0};